import router from '@/router'
import { setAuth } from '@/lib/storage'
import rules from './rules'
import {
  inviteIsVold,
  loginOrRegisterInvite,
  supplyUsersInfoInvite,
  joinOrgInfo
} from '@/services/team'
export default {
  namespaced: true,
  state: {
    companyDatas: {},
    auth: '',
    inviteInfo: {},
    invitecode: '',
    decorators: {
      mobile: ['mobile', { rules: rules.tel }],
      username: ['username', { rules: rules.username }],
      password: ['password', { rules: rules.password }],
      checkcode: ['checkcode', { rules: rules.validCode }]
    }
  },
  mutations: {
    setCompanyDatas (state, data) {
      state.companyDatas = data
    },
    setAuth (state, data) {
      state.auth = data
    },
    setInviteCode (state, data) {
      state.invitecode = data
    }
  },
  actions: {
    async fetchInviteIsVold ({ commit, state }) {
      const chain = await inviteIsVold()
        .params({ invitecode: state.invitecode })
        .onNetSuccess(raw => {
          if (raw.data.error === 0) {
            commit('setCompanyDatas', raw.data.payload)
            const company = raw.data.payload
            if (!state.auth) {
              router.push({
                path: '/teamInvite/login',
                query: {
                  invitecode: state.invitecode,
                  comname: company.comname,
                  projectname: company.projectname
                }
              })
            } else {
              router.push({
                path: '/teamInvite/result',
                query: {
                  invitecode: state.invitecode,
                  comname: company.comname,
                  projectname: company.projectname,
                  inviteuser: company.inviteuser
                }
              })
            }
          } else if (raw.data.error === 100) {
            router.push({ name: 'TeamInviteLose' })
          }
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    async fetchLoginOrRegisterInvite ({ commit, state, dispatch }, params) {
      const chain = await loginOrRegisterInvite()
        .params({ ...params })
        .onNetSuccess(raw => {
          if (raw.data.error === 0) {
            const payload = raw.data.payload
            if (payload.isreg === 0) {
              router.push({
                path: '/teamInvite/success',
                query: {
                  ensecret: payload.ensecret,
                  ...params
                }
              })
            } else {
              setAuth(payload.Authorization)
              commit('setAuth', payload.Authorization, { root: true })
              dispatch('fetchJoinOrgInfo', params)
            }
          } else if (raw.data.error === 100) {
          }
        })
        .config({
          tip: false
        })
      return chain
    },
    async fetchSupplyUsersInfoInvite ({ commit, dispatch }, params) {
      const { form, mobile, password, username, invitecode, ensecret } = params
      const json = {
        mobile,
        password,
        username,
        invitecode,
        ensecret
      }
      const chain = await supplyUsersInfoInvite()
        .params(json)
        .onNetSuccess(raw => {
          if (raw.data.error === 0) {
            const payload = raw.data.payload
            setAuth(payload.Authorization)
            commit('setAuth', payload.Authorization, { root: true })
            dispatch('fetchJoinOrgInfo', params)
          }
        })
        .config({
          tip: true,
          warn: true
        })
        .setForm(form)
      return chain
    },
    async fetchJoinOrgInfo ({ commit, state }, params) {
      const chain = await joinOrgInfo()
        .params({ invitecode: params.invitecode })
        .onNetSuccess(raw => {
          if (raw.data.error === 0) {
            router.push({ name: 'OrgIndex' })
          } else if (raw.data.error === 100) {
          }
        })
        .config({
          tip: true
        })
        .fetch()
      return chain
    }
  }
}
